function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M336.969 945.103l1098.19 0c24.9378,0 47.6339,10.1551 64.0583,26.5713 16.4327,16.4162 26.6008,39.0945 26.6008,64.0205l0 226.884c0,25.0453 -10.1681,47.7225 -26.6008,64.1351 -16.4244,16.4197 -39.1205,26.5795 -64.0583,26.5795l-14.0043 0c-11.0563,-43.6087 -33.7335,-83.7237 -66.2138,-116.182 -47.3504,-47.3185 -111.093,-73.7316 -178.048,-73.7316 -66.991,0 -130.746,26.4083 -178.155,73.715 -32.511,32.4402 -55.1268,72.5764 -66.1418,116.198l-161.539 0c-11.0551,-43.6087 -33.7311,-83.7237 -66.2138,-116.183 -47.354,-47.3185 -111.091,-73.7304 -178.049,-73.7304 -66.991,0 -130.74,26.4095 -178.149,73.7138 -28.2461,28.1858 -49.0241,62.178 -61.2154,99.2186 -2.69646,-2.09291 -5.25827,-4.35118 -7.6689,-6.76064 -14.6599,-14.6492 -23.7614,-34.8437 -23.7614,-57.1689l0 -246.375c0,-22.324 9.10158,-42.5233 23.7614,-57.1678 14.6516,-14.6457 34.8673,-23.7366 57.2079,-23.7366l0 -0.0011811z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1296.39 996.714c-7.20709,-9.32835 -19.7398,-26.3386 -36.1689,-48.6579 -63.117,-85.5142 -185.693,-251.932 -189.591,-251.932l-738.745 0c-2.60197,0 -5.20394,1.41851 -7.21418,3.54331 -2.83347,3.18898 -4.60866,7.91457 -4.60866,13.3465l0 295.393 -64.0642 0 0 -295.393c0,-21.4973 8.15316,-41.2193 21.1583,-55.7481 13.9476,-15.5906 33.3319,-25.1575 54.7288,-25.1575l738.745 0c36.0473,0 171.504,183.781 241.126,278.269 17.2559,23.387 30.3744,41.1036 34.9878,47.0055l-50.354 39.3307z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "727.26,664.117 727.26,977.11 663.2,977.11 663.2,664.117 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1480.55 413.015l208.976 0c26.1236,0 49.7622,10.6287 66.9001,27.7559 17.1414,17.1236 27.776,40.7469 27.776,66.8504 0,26.1012 -10.6347,49.7256 -27.776,66.8493 -17.1378,17.1272 -40.7776,27.7559 -66.9001,27.7559l-208.976 0 0 -189.212zm-1106.35 0l1074.79 0 0 189.212 -1074.79 0c-26.1213,0 -49.7622,-10.6287 -66.9024,-27.7559 -17.1343,-17.1248 -27.776,-40.7469 -27.776,-66.8493 0,-26.1036 10.6417,-49.7268 27.776,-66.8504 17.1402,-17.1284 40.7811,-27.7559 66.9024,-27.7559l0 0z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "1698.15,590.533 1698.15,1053.06 1634.09,1053.06 1634.09,590.533 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1792 1128.29c-6.38504,23.9729 -20.5666,44.4071 -39.4748,58.9347 -18.7937,14.4095 -42.0839,22.7929 -67.0229,22.7929 -30.4925,0 -58.0371,-12.398 -78.0119,-32.3575 -19.9748,-19.9666 -32.2677,-47.4804 -32.2677,-77.9564 0.0011811,-30.3532 12.2929,-57.991 32.2677,-77.9528 19.9748,-19.9583 47.5193,-32.2418 78.0119,-32.2418l0 64.0158c-12.763,0 -24.3484,5.19567 -32.7449,13.4599 -8.39056,8.39174 -13.4728,19.963 -13.4728,32.7189 0.0011811,12.7595 5.08229,24.3319 13.4728,32.7177 8.39764,8.38465 19.9807,13.5827 32.7449,13.5827 10.5213,0 20.4508,-3.54095 28.2484,-9.56694 7.92048,-6.02599 13.8307,-14.5276 16.5473,-24.6862l44.9185 -35.4343 16.7835 51.9733z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "695.938,601.518 695.938,653.134 631.874,653.134 631.874,601.518 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "977.726,601.518 977.726,653.134 913.781,653.134 913.781,601.518 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M593.695 1482.03c-17.139,17.1295 -40.7764,27.7559 -66.9001,27.7559 -26.1213,0 -49.878,-10.6264 -67.0182,-27.7559 -17.0244,-17.0055 -27.6567,-40.7469 -27.6567,-66.8445 0,-26.1071 10.6323,-49.7256 27.6567,-66.854 17.1402,-17.126 40.8957,-27.7559 67.0182,-27.7559 26.1236,0 49.7611,10.6299 66.9001,27.7559 17.1402,17.1272 27.7807,40.7469 27.7807,66.854 0,26.0977 -10.6406,49.839 -27.7807,66.8445zm88.5296 -222.282c-39.7134,-39.6851 -94.6725,-64.3666 -155.43,-64.3666 -60.7548,0 -115.719,24.6815 -155.547,64.3666 -39.8386,39.8067 -64.4245,94.7233 -64.4245,155.438 0,60.7052 24.5858,115.626 64.4245,155.428 39.828,39.8079 94.7918,64.3713 155.547,64.3713 60.7571,0 115.716,-24.5634 155.43,-64.3713 39.8374,-39.802 64.539,-94.7233 64.539,-155.428 0,-60.7146 -24.7016,-115.631 -64.539,-155.438z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M526.794 1384.59c-8.50867,0 -16.1929,3.4252 -21.6284,8.97875 -5.55945,5.54882 -8.98583,13.2236 -8.98583,21.6154 0,8.5004 3.42638,16.0571 8.98583,21.6106 5.43544,5.54882 13.1197,8.97875 21.6284,8.97875 8.39174,0 16.076,-3.42874 21.6319,-8.97875 5.55473,-5.55355 8.98111,-13.1102 8.98111,-21.6106 0,-8.39174 -3.42638,-16.0665 -8.98111,-21.6154 -5.55591,-5.55355 -13.2402,-8.97875 -21.6319,-8.97875z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1176.89 1384.59c-8.51457,0 -16.1941,3.4252 -21.6343,8.97875 -5.55355,5.54882 -8.98111,13.2236 -8.98111,21.6154 0,8.5004 3.42756,16.0571 8.98111,21.6106 5.44016,5.54882 13.1197,8.97875 21.6343,8.97875 8.39056,0 16.0701,-3.42874 21.6284,-8.97875 5.55827,-5.55355 8.98465,-13.1102 8.98465,-21.6106 0.0011811,-8.39174 -3.42756,-16.0665 -8.98465,-21.6154 -5.55827,-5.55355 -13.2378,-8.97875 -21.6284,-8.97875z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1243.79 1482.03c-17.1378,17.1295 -40.7811,27.7559 -66.9001,27.7559 -26.1248,0 -49.8815,-10.6264 -67.0241,-27.7559 -17.0197,-17.0055 -27.6544,-40.7469 -27.6544,-66.8445 0,-26.1071 10.6347,-49.7256 27.6544,-66.854 17.1425,-17.126 40.8992,-27.7559 67.0241,-27.7559 26.1189,0 49.7622,10.6299 66.9001,27.7559 17.1425,17.1272 27.776,40.7469 27.776,66.854 0.0011811,26.0977 -10.6347,49.839 -27.776,66.8445zm88.5284 -222.282c-39.7134,-39.6851 -94.6772,-64.3666 -155.428,-64.3666 -60.7536,0 -115.721,24.6815 -155.552,64.3666 -39.8327,39.8067 -64.4174,94.7233 -64.4174,155.438 0,60.7052 24.5847,115.626 64.4174,155.428 39.8327,39.8079 94.7989,64.3713 155.552,64.3713 60.7524,0 115.714,-24.5634 155.428,-64.3713 39.8339,-39.802 64.5402,-94.7233 64.5402,-155.428 0,-60.7146 -24.7075,-115.631 -64.5402,-155.438z"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  width: 2048,
  height: 2048
});

var SvgCrane1 = function SvgCrane1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrane1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Crane1.1821c4ed.svg";
export { ForwardRef as ReactComponent };